var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 1.03125C8.86566 1.03125 8.25 1.64691 8.25 2.40625V3.09375H8.11237L2.40625 3.78125V4.8125H19.5938V3.78125L13.8876 3.09375H13.75V2.40625C13.75 1.64691 13.1343 1.03125 12.375 1.03125H9.625ZM9.625 2.40625H12.375V3.09375H9.625V2.40625ZM3.4375 5.5L4.8125 19.9375H17.1875L18.5363 5.84375L3.4375 5.5ZM11 7.90625C11.4582 7.90625 11.6875 8.25 11.6875 8.25V18.2188H10.3125V8.25C10.3125 8.25 10.5418 7.90625 11 7.90625ZM6.52319 7.93042C6.98038 7.89845 7.23352 8.22583 7.23352 8.22583L7.90894 18.2188H6.52991L5.86188 8.32117C5.86188 8.32117 6.06601 7.96239 6.52319 7.93042ZM15.4614 7.93042C15.9186 7.96239 16.1234 8.32117 16.1234 8.32117L15.4553 18.2188H14.0763L14.7517 8.22583C14.7517 8.22583 15.0042 7.89845 15.4614 7.93042Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.7de817c1b7bc1b48a8a24545574de233.svg";
export { ForwardRef as ReactComponent };